<div class="chat-threads">
  <div *ngIf="loading" class="chat-threads__state">{{ loadingText }}</div>
  <div *ngIf="loadError && !loading" class="chat-threads__state chat-threads__state--error">{{ loadError }}</div>

  <ng-container *ngIf="!loading && !loadError">
    <div *ngIf="threads.length === 0" class="chat-threads__state">{{ emptyText }}</div>

    <div class="chat-threads__layout" *ngIf="threads.length > 0">
      <div class="chat-threads__list">
        <button
          type="button"
          class="chat-threads__item"
          *ngFor="let thread of threads"
          [class.chat-threads__item--active]="thread.forwarderId === selectedForwarderId"
          (click)="select(thread.forwarderId)"
        >
          <span class="chat-threads__item-label">{{ thread.label }}</span>
          <span class="chat-threads__item-snippet" *ngIf="thread.lastMessageSnippet">{{ thread.lastMessageSnippet }}</span>
        </button>
      </div>

      <div class="chat-threads__chat">
        <app-chat
          *ngIf="selectedForwarderId"
          contextType="REQUEST"
          [contextId]="requestId"
          [forwarderId]="selectedForwarderId"
          [locked]="locked"
        ></app-chat>
      </div>
    </div>
  </ng-container>
</div>
